import {APP_PREFIX_PATH} from "../AppConfig";
import React from "react";

export const keuanganRolesPages = [
    {
        key: 'keuangan',
        path: `${APP_PREFIX_PATH}/keuangan`,
        component: React.lazy(() => import('views/keuangan-views')),
    },

    // ROUTING DATA
    {
        key: 'keuangan.data',
        path: `${APP_PREFIX_PATH}/keuangan/data`,
        component: React.lazy(() => import('views/keuangan-views/data')),
    },
    {
        key: 'keuangan.data.mahasiswa',
        path: `${APP_PREFIX_PATH}/keuangan/data/mahasiswa`,
        component: React.lazy(() => import('views/keuangan-views/data/mahasiswa')),
    },
    {
        key: 'keuangan.data.mahasiswa.detail',
        path: `${APP_PREFIX_PATH}/keuangan/data/mahasiswa/detail`,
        component: React.lazy(() =>import('views/keuangan-views/data/mahasiswa/detail/DetailPembayaranMahasiswa')),
    },
    {
        key: 'keuangan.data.mahasiswa.edit-detail',
        path: `${APP_PREFIX_PATH}/keuangan/data/mahasiswa/edit-detail`,
        component: React.lazy(() =>import('views/keuangan-views/data/mahasiswa/edit/EditDetailPembayaran')),
    },
    {
        key: 'keuangan.data.mahasiswa.add',
        path: `${APP_PREFIX_PATH}/keuangan/data/mahasiswa/add`,
        component: React.lazy(() =>import('views/keuangan-views/data/mahasiswa/add')),
    },


    {
        key: 'keuangan.data.mahasiswa.detail.verifikasi',
        path: `${APP_PREFIX_PATH}/keuangan/data/mahasiswa/detail/verifikasi`,
        component: React.lazy(() =>import('views/keuangan-views/data/mahasiswa/detail/verifikasi/VerifikasiPembayaran')),
    },
    {
        key: 'keuangan.data.check-bayar',
        path: `${APP_PREFIX_PATH}/keuangan/data/check-bayar`,
        component: React.lazy(() => import('views/keuangan-views/data/check-bayar')),
    },

    // ROUTING SETTING
    {
        key: 'keuangan.setting',
        path: `${APP_PREFIX_PATH}/keuangan/setting`,
        component: React.lazy(() => import('views/keuangan-views/setting')),
    },
    {
        key: 'keuangan.setting.rekening',
        path: `${APP_PREFIX_PATH}/keuangan/setting/rekening`,
        component: React.lazy(() => import('views/keuangan-views/setting/rekening')),
    },
    {
        key: 'keuangan.setting.pembayaran',
        path: `${APP_PREFIX_PATH}/keuangan/setting/pembayaran`,
        component: React.lazy(() => import('views/keuangan-views/setting/pembayaran')),
    },

    // ROUTING LAPORAN
    {
        key: 'keuangan.laporan',
        path: `${APP_PREFIX_PATH}/keuangan/laporan`,
        component: React.lazy(() => import('views/keuangan-views/laporan')),
    },
    {
        key: 'keuangan.laporan.pembayaran',
        path: `${APP_PREFIX_PATH}/keuangan/laporan/pembayaran`,
        component: React.lazy(() => import('views/keuangan-views/laporan/pembayaran')),
    },
    {
        key: 'keuangan.laporan.penarikan',
        path: `${APP_PREFIX_PATH}/keuangan/laporan/penarikan`,
        component: React.lazy(() => import('views/keuangan-views/laporan/penarikan')),
    },
    {
        key: 'keuangan.laporan.tunggakan',
        path: `${APP_PREFIX_PATH}/keuangan/laporan/tunggakan`,
        component: React.lazy(() => import('views/keuangan-views/laporan/tunggakan')),
    },
    {
        key: 'keuangan.laporan.lunas',
        path: `${APP_PREFIX_PATH}/keuangan/laporan/lunas`,
        component: React.lazy(() => import('views/keuangan-views/laporan/lunas')),
    },

    // ROUTING ADMINISTRASI
    {
        key: 'keuangan.administrasi',
        path: `${APP_PREFIX_PATH}/keuangan/administrasi`,
        component: React.lazy(() => import('views/keuangan-views/administrasi')),
    },
    {
        key: 'keuangan.administrasi.master-letak-kampus',
        path: `${APP_PREFIX_PATH}/keuangan/administrasi/master-letak-kampus`,
        component: React.lazy(() => import('views/keuangan-views/administrasi/master-letak-kampus')),
    },
    {
        key: 'keuangan.administrasi.mapping-letak-kampus-mhs',
        path: `${APP_PREFIX_PATH}/keuangan/administrasi/mapping-letak-kampus-mhs`,
        component: React.lazy(() => import('views/keuangan-views/administrasi/mapping-letak-kampus-mhs')),
    },
    {
        key: 'keuangan.administrasi.mapping-letak-kampus-mhs.add',
        path: `${APP_PREFIX_PATH}/keuangan/administrasi/mapping-letak-kampus-mhs/add`,
        component: React.lazy(() => import('views/keuangan-views/administrasi/mapping-letak-kampus-mhs/add')),
    },
    {
        key: 'keuangan.administrasi.beasiswa',
        path: `${APP_PREFIX_PATH}/keuangan/administrasi/beasiswa`,
        component: React.lazy(() => import('views/keuangan-views/administrasi/beasiswa')),
    },
    {
        key: 'keuangan.administrasi.beasiswa.add',
        path: `${APP_PREFIX_PATH}/keuangan/administrasi/beasiswa/add`,
        component: React.lazy(() => import('views/keuangan-views/administrasi/beasiswa/add')),
    },
    {
        key: 'keuangan.administrasi.generate_pembayaran',
        path: `${APP_PREFIX_PATH}/keuangan/administrasi/generate_pembayaran`,
        component: React.lazy(() => import('views/keuangan-views/administrasi/generate_pembayaran')),
    },
    {
        key: 'keuangan.administrasi.generate-tagihan',
        path: `${APP_PREFIX_PATH}/keuangan/administrasi/generate-tagihan`,
        component: React.lazy(() => import('views/keuangan-views/administrasi/generate-tagihan')),
    },
    {
        key: 'keuangan.setting.tarif-pembayaran',
        path: `${APP_PREFIX_PATH}/keuangan/setting/tarif-pembayaran`,
        component: React.lazy(() => import('views/keuangan-views/setting/tarif-pembayaran')),
    },
    {
        key: 'keuangan.setting.cicilan-config',
        path: `${APP_PREFIX_PATH}/keuangan/setting/cicilan-config`,
        component: React.lazy(() => import('views/keuangan-views/setting/cicilan-config')),
    },

]